import { z } from 'zod';

export const BookingStatus = z.enum(['confirmed', 'canceled']);
export type BookingStatus = z.infer<typeof BookingStatus>;

/**
 * Audit field — which track of the LBRE workflow this booking came from.
 * - `off-site` (default) = Scenario 2: vendor takes vehicle off-site
 * - `on-site` = Scenario 1: vendor visits the vehicle on campus
 *
 * Runtime behavior is identical; the field is reporting-only.
 */
export const BookingSourceScenario = z.enum(['off-site', 'on-site']);
export type BookingSourceScenario = z.infer<typeof BookingSourceScenario>;

export const ServiceWindowBooking = z.object({
  id: z.string().uuid(),
  windowId: z.string().uuid(),
  vehicleId: z.string().uuid(),
  operatorUserId: z.string().uuid(),
  status: BookingStatus,
  bookingSourceScenario: BookingSourceScenario.default('off-site'),
  stagingAppointmentId: z.string().uuid(),
  confirmedAt: z.string().datetime(),
  canceledAt: z.string().datetime().nullable().optional(),
  cancelReason: z.string().max(500).nullable().optional(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type ServiceWindowBooking = z.infer<typeof ServiceWindowBooking>;

export const CreateBookingInput = z.object({
  vehicleId: z.string().uuid(),
  /** Optional override for ad-hoc / coordinator-driven on-site bookings. Defaults to 'off-site'. */
  bookingSourceScenario: BookingSourceScenario.optional(),
});
export type CreateBookingInput = z.infer<typeof CreateBookingInput>;

export const CancelBookingInput = z.object({
  cancelReason: z.string().max(500).optional(),
});
export type CancelBookingInput = z.infer<typeof CancelBookingInput>;
